<template>
  <div class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('nav.home')}}</router-link></li>
        <i v-if="userLang" class="fa-solid fa-chevron-left pt-1"></i>
        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
        <router-link to="/realEstateBulletin">
          <li class="breadcrumb-item mx-3 almarai-bold">{{$t('realEstateBulletin')}}</li>
        </router-link>
        <i v-if="userLang" class="fa-solid fa-chevron-left pt-1"></i>
        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="breadcrumb-item mx-3 almarai-bold" aria-current="page">{{$t('realEstateBulletin_Details')}}</li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="row">
      <div class="col">
        <div class="row justify-content-center">
          <div class="col-12 col-md-12">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber"/>
          </div>
        </div>
        <div v-if="isLoading" class="row justify-content-center">
          <div class="col text-center">
            <mainloader />
          </div>
        </div>
        <div v-else class="row">
          <div class="col">
            <div class="row pt-3 justify-content-center">
              <div class="col-12 col-md-5">
                <img :src="MEDIA_URL+row.image" class="w-100" alt="">
              </div>
            </div>
            <div class="row pt-2">
              <div class="col almarai-bold">
                {{row.title}}
              </div>
            </div>
            <div class="row pt-1">
              <div class="col font-color-84">
                <img src="/assets/images/icons/calendar-03.png" class="max-20" alt="">
                <span class="mx-1">{{$t('publishedIn')}}</span>
                <span class="mx-1">{{row.publishDate}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "realEstateBulletinDetails",
  data(){
    return {
      propertyId: this.$route.query.propertyId,
      isLoading: false,
      hasError: false,
      errorNumber: 0,
      message: "",
      row: {},
      userLang: "ar",
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    latestNewsRetrieve(){
      this.isLoading = true;
      this.$http.get('/api/LatestNews/retrieve/'+this.propertyId).then(res => {
        // console.log(res);
        this.row = res.data.row;
        this.isLoading = false;
      }).catch(err => {
        console.log(err);
        this.isLoading = false;
      })
    }
    
  },
  created(){
    this.latestNewsRetrieve();
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({top:0, behavior:'smooth'});
  }
}
</script>